import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeferredConfigModel } from '../../models/start-up-config/deferred-config';
import { UrlConfigModel } from '../../models/start-up-config/initial-config.model';
import { SessionInfoModel } from '../../models/start-up-config/session-info-model';
import { CustomizedHttpService } from '../base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class StartUpConfigService {
  constructor(private httpService: CustomizedHttpService) {}

  getSessionConfig(): Observable<SessionInfoModel> {
    return this.httpService.get<SessionInfoModel>('Config/getSessionConfig');
  }

  getInitialConfig(): Observable<UrlConfigModel> {
    return this.httpService.get<UrlConfigModel>('Config/getInitialConfig');
  }

  getDeferredConfig(): Observable<DeferredConfigModel> {
    return this.httpService.get<DeferredConfigModel>('Config/getDeferredConfig');
  }
}
